import React from 'react';
import { Timeline, Events, UrlButton, ImageEvent } from '@merc/react-timeline';

import L_Coursehub from '../../assets/img/projects/coursehub.png';
import L_Multilevel from '../../assets/img/projects/multilevel.png';
import L_Blog from '../../assets/img/projects/blog.png';
import L_Todo from '../../assets/img/projects/todo.png';
import L_Vegan from '../../assets/img/projects/vegan.png';
import L_DevConnector from '../../assets/img/projects/devinonestage.png';

import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import L_REACT from '../../assets/img/skills/react.svg';
import L_NODE_JS from '../../assets/img/skills/nodejs.svg';
import L_SNIPCART from '../../assets/img/skills/snipcart.png';
import L_CONTENTFUL from '../../assets/img/skills/contentful.png';
import L_MONGODB from '../../assets/img/skills/mongodb.png';
import L_EJS from '../../assets/img/skills/ejs.png';

import L_EXPRESS from '../../assets/img/skills/express.svg';
import L_GATSBY from '../../assets/img/skills/gatsby.png';
import L_Netlify from '../../assets/img/skills/netlify.png';
import Image from 'react-bootstrap/Image';
import L_HTML5 from '../../assets/img/skills/html-5.svg';
import L_CSS3 from '../../assets/img/skills/css3.svg';
import L_BOOTSTRAP4 from '../../assets/img/skills/bootstrap-4.svg';
import L_GITHUB_PAGES from '../../assets/img/skills/github.svg';
import L_HEROKU from '../../assets/img/skills/heroku.svg';
import L_REDUX from '../../assets/img/skills/redux.svg';
import L_SASS from '../../assets/img/skills/sass-1.svg';

import './projects-timeline.styles.css';

export default function TimeLine() {
  return (
    <div id='projects'>
      <h1 className='pt-3 text-center font-details-b pb-3'>PROJECTS</h1>
      <Timeline>
        <Events>
          {/* Project : DevConnetor */}
          <ImageEvent
            date='20/08/2020'
            className='text-center'
            text='Dev-Connector'
            src={L_DevConnector}
            alt='DevConnector'
          >
            <div className='d-flex justify-content-between flex-column mt-1'>
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey='0'
                      className='p-2 text-center accordian-main'
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey='0' className='text-left'>
                      <Card.Body>
                        <strong>Description:</strong>DevConnector is a
                        developer-focused social platform that allows users to
                        communicate with their peers and showcase their
                        developer credentials. Users can create profiles (with
                        detailed information on their technical skills,
                        educational and work experience, and the user’s most
                        recent GitHub repositories), view a list of all
                        developers on the platform, and create posts that can be
                        liked/unliked and commented on by other users. The
                        Node.js/Express.js server features over 20 endpoints
                        that handle authenticating users,
                        Create/Read/Update/Delete operations for user validation
                        (using the passport.js JSON Web Token strategy), profile
                        and post data, and extensive input validation and error
                        handling.
                        <hr />
                        <strong>Features:</strong>
                        <ul className='list-styles pt-1'>
                          <li>Signup a new User.</li>
                          <li>Signin with an existing User.</li>
                          <li>Create/Update/Delete your profile.</li>
                          <li>
                            Link your profile to Github to add recent 5
                            repositories to your DevConnector Profile.
                          </li>
                          <li>View other Developer's profile</li>
                          <li>Create/Update/Delete your Post</li>
                          <li>Add/Remove Likes on other's posts</li>
                          <li>Add/Remove Comments on other's posts</li>
                          <li>Get an alert based on your action's</li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_REACT}
                                alt='React'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              React
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_REDUX}
                                alt='REDUX'
                                rounded
                                className='image-style m-1'
                              ></Image>{' '}
                              Redux
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_CSS3}
                                alt='CSS3'
                                rounded
                                className='image-style m-1'
                              ></Image>{' '}
                              CSS3
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_SASS}
                                alt='SASS'
                                rounded
                                className='image-style m-1'
                              ></Image>{' '}
                              SASS
                            </span>
                          </li>

                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_NODE_JS}
                                alt='Node.js'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Node.js
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_EXPRESS}
                                alt='Express'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Express
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_MONGODB}
                                alt='Mongodb Atlas'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              MongoDB Atlas
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_HEROKU}
                                alt='Heroku'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Heroku
                            </span>
                          </li>
                        </ul>
                        <hr />
                        <em>
                          <strong>Contact me for Source Code </strong>
                          <br />
                          <strong>
                            **NOTE: Use a authentic email-id while signing up to
                            have a profile picture same as your gmail account**
                          </strong>
                        </em>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className='d-flex justify-content-between flex-nowrap text-center'>
                <UrlButton
                  href='https://devinonestage.herokuapp.com'
                  target='_blank'
                >
                  SEE LIVE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: COURSE HUB */}
          <ImageEvent
            date='20/07/2020'
            className='text-center'
            text='Course Hub'
            src={L_Coursehub}
            alt='Course Hub'
          >
            <div className='d-flex justify-content-between flex-column mt-1'>
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey='0'
                      className='p-2 text-center accordian-main'
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey='0' className='text-left'>
                      <Card.Body>
                        <strong>Description:</strong> An fully functional and
                        responsive "E-Commerce Web app" .
                        <hr />
                        <strong>Features:</strong>
                        <ul className='list-styles pt-1'>
                          <li>Register new user using Snipcart</li>
                          <li>Signin exiting user</li>
                          <li>Add items to Cart</li>
                          <li>Pay securely using Snipcart</li>
                          <li>
                            Notify Admin and Customer through email when order
                            is successfully placed.
                          </li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_REACT}
                                alt='React'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              React
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_GATSBY}
                                alt='Gatsby'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Gatsby
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_CONTENTFUL}
                                alt='Contentful'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Contentful
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_SNIPCART}
                                alt='Snipcart'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Snipcart
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_Netlify}
                                alt='PostgreSQL'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Netlify
                            </span>
                          </li>
                        </ul>
                        <hr />
                        <em>
                          <strong>Contact me for Source Code </strong>
                          <br />
                          <strong>
                            **NOTE: Snipcart is currently running in TEST
                            Enviroment**
                          </strong>
                        </em>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className='d-flex justify-content-between flex-nowrap text-center'>
                <UrlButton
                  href='https://mygatsbye-commerce.netlify.app/'
                  target='_blank'
                >
                  SEE LIVE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: MULTILEVEL LOGIN SYSTEM */}

          <ImageEvent
            date='14/06/2020'
            className='text-center'
            text='Multilevel Login System'
            src={L_Multilevel}
            alt='Multilevel'
          >
            <div className='d-flex justify-content-between flex-column mt-1'>
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey='0'
                      className='p-2 text-center accordian-main'
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey='0' className='text-left'>
                      <Card.Body>
                        <strong>Description:</strong> An multilevel login system
                        build for a company "QuotesNStories" as a assignment.
                        <hr />
                        <strong>Features:</strong>
                        <ul className='list-styles pt-1'>
                          <li>Signup a new User.</li>
                          <li>Signin with an existing User.</li>
                          <li>
                            Admin and Customer have a different UI of Dashboard.
                          </li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_REACT}
                                alt='React'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              React
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_BOOTSTRAP4}
                                alt='Bootstrap'
                                rounded
                                className='image-style m-1'
                              ></Image>{' '}
                              Bootstrap
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_NODE_JS}
                                alt='Node.js'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Node.js
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_EXPRESS}
                                alt='Express'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Express
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_MONGODB}
                                alt='Mongodb Atlas'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              MongoDB Atlas
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_HEROKU}
                                alt='Heroku'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Heroku
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className='d-flex justify-content-between flex-nowrap text-center'>
                <UrlButton
                  href='https://mernauthwebapp.herokuapp.com/'
                  target='_blank'
                >
                  SEE LIVE
                </UrlButton>
                <UrlButton
                  href='https://github.com/ayushat/mernauthwebapp.git'
                  target='_blank'
                >
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: DAILY JOURNAl */}

          <ImageEvent
            date='25/05/2019'
            className='text-center'
            text='Daily Journal'
            src={L_Blog}
            alt='Daily Journal'
          >
            <div className='d-flex justify-content-between flex-column mt-1'>
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey='0'
                      className='p-2 text-center accordian-main'
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey='0' className='text-left'>
                      <Card.Body>
                        <strong>Description:</strong> A simple website for
                        blogging.
                        <hr />
                        <strong>Features:</strong>
                        <ul className='list-styles pt-1'>
                          <li>User can create a blog</li>
                          <li>User can read other user's posts</li>
                          <li>Can delete the post </li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_HTML5}
                                alt='HTML 5'
                                rounded
                                className='image-style m-1'
                              ></Image>{' '}
                              HTML5
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_EJS}
                                alt='EJS'
                                rounded
                                className='image-style m-1'
                              ></Image>{' '}
                              EJS
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_BOOTSTRAP4}
                                alt='Bootstrap 4'
                                rounded
                                className='image-style m-1'
                              ></Image>{' '}
                              Bootstrap 4
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_NODE_JS}
                                alt='Node.js'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Node.js
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_EXPRESS}
                                alt='Express'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Express
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_MONGODB}
                                alt='Mongodb Atlas'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              MongoDB Atlas
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_HEROKU}
                                alt='Heroku'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Heroku
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className='d-flex justify-content-between flex-nowrap text-center'>
                <UrlButton
                  href='https://blooming-shore-26307.herokuapp.com/'
                  target='_blank'
                >
                  SEE LIVE
                </UrlButton>
                <UrlButton
                  href='https://github.com/ayushat/Daily-Journal-Web-App.git'
                  target='_blank'
                >
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: ToDo */}
          <ImageEvent
            date='01/05/2020'
            className='text-center'
            text='ToDO Web App'
            src={L_Todo}
            alt='ToDo'
          >
            <div className='d-flex justify-content-between flex-column mt-1'>
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey='0'
                      className='p-2 text-center accordian-main'
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey='0' className='text-left'>
                      <Card.Body>
                        <strong>Description:</strong> “The ideal todo app should
                        be effortless, simple, and actually save you time.”
                        <hr />
                        <strong>Features:</strong>
                        <ul className='list-styles pt-1'>
                          <li>Make entries of your Tasks</li>
                          <li>
                            Delete your task by simplily clicking the checkbox
                          </li>
                          <li>
                            <strong>
                              User can CREATE the ToDO list with prefered LIST
                              TITLE
                            </strong>
                          </li>
                          <li>Fully funtional and responsive</li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_HTML5}
                                alt='HTML 5'
                                rounded
                                className='image-style m-1'
                              ></Image>{' '}
                              HTML5
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_CSS3}
                                alt='CSS 3'
                                rounded
                                className='image-style m-1'
                              ></Image>{' '}
                              CSS3
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_EJS}
                                alt='EJS'
                                rounded
                                className='image-style m-1'
                              ></Image>{' '}
                              EJS
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_NODE_JS}
                                alt='Node.js'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Node.js
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_EXPRESS}
                                alt='Express'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Express
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_MONGODB}
                                alt='Mongodb Atlas'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              MongoDB Atlas
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_HEROKU}
                                alt='Heroku'
                                rounded
                                className='image-style1 m-1'
                              ></Image>{' '}
                              Heroku
                            </span>
                          </li>
                        </ul>
                        <hr />
                        <em>
                          <strong>INSTRUCTIONS</strong>
                          <br />
                          <br />
                          1.User can CREATE a Custom List.
                          <br />
                          2.Write your custom list name after the "url" to
                          CREATE a Custom List.
                          <br />
                          <strong>
                            **NOTE : For security reasons create a list with
                            "UNIQUE LIST TITLE" **
                          </strong>
                          <br />
                          2.To Read more click the "about" button below.
                          <br />
                          <br />
                        </em>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className='d-flex justify-content-between flex-nowrap text-center'>
                <UrlButton
                  href='https://rocky-fortress-13205.herokuapp.com/about'
                  target='_blank'
                >
                  ABOUT
                </UrlButton>
                <UrlButton
                  href='https://rocky-fortress-13205.herokuapp.com/'
                  target='_blank'
                >
                  SEE LIVE
                </UrlButton>
                <UrlButton
                  href='https://github.com/ayushat/ToDo-Web-App.git'
                  target='_blank'
                >
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* VEGAN STORE*/}
          <ImageEvent
            date='10/04/2020'
            className='text-center'
            text='Vegan Store'
            src={L_Vegan}
            alt='Vegan Store'
          >
            <div className='d-flex justify-content-between flex-column mt-1'>
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey='0'
                      className='p-2 text-center accordian-main'
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey='0' className='text-left'>
                      <Card.Body>
                        <strong>Description:</strong>A pure HTML5 and CSS3 using
                        responsive website to showcase the power of CSS.
                        <hr />
                        <strong>Features:</strong>
                        <ul className='list-styles pt-1'>
                          <li>Compatible with any device</li>
                          <li>Only CSS is used for styling</li>
                          <li>Deployed on github</li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_HTML5}
                                alt='HTML 5'
                                rounded
                                className='image-style m-1'
                              ></Image>{' '}
                              HTML5
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_CSS3}
                                alt='CSS 3'
                                rounded
                                className='image-style m-1'
                              ></Image>{' '}
                              CSS3
                            </span>
                          </li>
                          <li>
                            <span className='p-2'>
                              <Image
                                src={L_GITHUB_PAGES}
                                alt='Github pages'
                                rounded
                                className='image-style m-1'
                              ></Image>{' '}
                              Github
                            </span>
                          </li>
                        </ul>
                        <hr />
                        <em>
                          <strong>Contact me for Source Code</strong>
                          <br />
                          <br />
                          <strong>Click SEE LIVE to see website</strong>
                          <br />
                          <br />
                        </em>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className='d-flex justify-content-between flex-nowrap text-center'>
                <UrlButton
                  href='https://ayushat.github.io/Vegan-Store/'
                  target='_blank'
                >
                  SEE LIVE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>
        </Events>
      </Timeline>
    </div>
  );
}
